export default __webpack_public_path__ + "static/media/IMG_0211 copie.40b6658d.jpg";